import {makeStyles} from "@material-ui/core/styles";
import React, {useState} from "react";
import { connect } from 'react-redux'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";


const useStyles = makeStyles(theme => ({
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: theme.spacing(1) * 10,
        width: '100%'
    },
    relative: {
        position: 'relative'
    },
    textControl : {
        paddingTop: 0,
        paddingBottom: 5,
    },
    row: {
        marginBottom: theme.spacing(1),
    }
}));


const ImportarOSTenantDialog = ({
                              isOpen,
                              isAddNewRecord,
                              closeDialog,
                              importOS
                          }) => {


    const classes = useStyles();
    const [open, setOpen] = useState(true);
    const [osCodigo, setosCodigo] = useState("");
    const [prioridade, setPrioridade] = useState(2);


    const onChangeOS = (event) => {
        const orderID = event.target.value;
        setosCodigo(orderID);

    }


    const handleImport = () => {
        console.log("handleImport", osCodigo);
        importOS(osCodigo, prioridade);
        setosCodigo("");
    }

    const onOrderIdChanged = (event) => {

    };


    console.log("ImportarOSDialog");


    return (<React.Fragment>
        <div>
        <Dialog fullWidth maxWidth={'md'} open={isOpen} onClose={closeDialog} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Importação Ordem de Servico</DialogTitle>
            <DialogContent>
                <Grid container item xs={12}  spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="order-label-placeholder" className={classes.relative}>
                                Num. Ordem Servico
                            </InputLabel>
                            <TextField
                                autoFocus
                                id="order"
                                label=""
                                type="text"
                                onChange={onChangeOS}
                                value={osCodigo}
                                className={classes.textControl}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="vida-label-placeholder" className={classes.relative}>
                                Prioridade
                            </InputLabel>
                            <Select
                                value={prioridade}
                                onChange={e => {setPrioridade(e.target.value)}}
                                inputProps={{
                                    name: 'prioridade',
                                    id: 'prioridade-label-placeholder',
                                }}
                                displayEmpty
                                name="prioridade"
                                className={classes.selectEmpty}

                            >
                                <MenuItem value="">
                                    <em>Selecione</em>
                                </MenuItem>
                                <MenuItem value="1" >BAIXA</MenuItem>
                                <MenuItem value="2" >NORMAL</MenuItem>
                                <MenuItem value="3" >RAPIDA</MenuItem>
                                <MenuItem value="4" >URGENTE</MenuItem>
                                <MenuItem value="5" >CLIENTE USA COMO ESTOQUE - 3meses</MenuItem>
                            </Select>
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>

                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleImport} color="default">
                    Importar
                </Button>
                <Button onClick={closeDialog} color="default">
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
        </div>
    </React.Fragment>)

}

export default connect(null, { })(ImportarOSTenantDialog)
